export function cartesianTyped<T1, T2>(...input: [T1[], T2[]]): [T1, T2][];
export function cartesianTyped<T1, T2, T3>(...input: [T1[], T2[], T3[]]): [T1, T2, T3][];
export function cartesianTyped<T1, T2, T3, T4>(...input: [T1[], T2[], T3[], T4[]]): [T1, T2, T3, T4][];
//export function cartesianTyped<T1, T2, T3, T4>(input: [T1[], T2[], T3[], T4[]]): [T1, T2, T3, T4][];
export function cartesianTyped<T1>(a: T1[]): [T1][];
export function cartesianTyped<T1, T2>(a: T1[], b: T2[]): [T1, T2][];
export function cartesianTyped<T1, T2, T3>(a: T1[], b: T2[], c: T3[]): [T1, T2, T3][];
export function cartesianTyped<T1, T2, T3, T4>(a: T1[], b: T2[], c: T3[], d: T4[]): [T1, T2, T3, T4][];
export function cartesianTyped<T1, T2, T3, T4, T5>(a: T1[], b: T2[], c: T3[], d: T4[], e: T5[]): [T1, T2, T3, T4, T5][];
export function cartesianTyped<T1, T2, T3, T4, T5>(input: [T1[], T2[], T3[], T4[], T5[]]): [T1, T2, T3, T4, T5][];
export function cartesianTyped<TA1, TA2, TA3, TB1>(a: [TA1, TA2, TA3][], b: TB1[]): [TA1, TA2, TA3, TB1][];
export function cartesianTyped<TA1, TA2, TA3, TA4, TB1>(a: [TA1, TA2, TA3, TA4][], b: TB1[]): [TA1, TA2, TA3, TA4, TB1][];
//eslint-disable-next-line @typescript-eslint/no-explicit-any
export function cartesianTyped(...a: any[][]): any[][] {
    return cartesian(...a);
}
export function cartesianTyped2<T1, T2, T3, T4, T5>(input: [T1[], T2[], T3[], T4[], T5[]]): [T1, T2, T3, T4, T5][];
export function cartesianTyped2<TA1, TA2, TA3, TB1>(a: [TA1, TA2, TA3][], b: TB1[]): [TA1, TA2, TA3, TB1][];
export function cartesianTyped2<TA1, TA2, TA3, TA4, TB1>(a: [TA1, TA2, TA3, TA4][], b: TB1[]): [TA1, TA2, TA3, TA4, TB1][];
//eslint-disable-next-line @typescript-eslint/no-explicit-any
export function cartesianTyped2(...a: any[][]): any[][] {
    return cartesian(...a);
}
export default function cartesian<T>(...a: T[][]): T[][] {
    //@ts-expect-error
    return a.reduce((a, b) => a.flatMap(d => b.map(e => [d, e].flat())));
}
